interface SearchParams {
  [key: string]: string | number | boolean | string[] | number[] | undefined;
}

export default function serializeSearchParams(params?: SearchParams) {
  if (!params) return "";

  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    const value = params[key];

    if (value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((val) => {
        searchParams.append(key, String(val));
      });
    } else {
      searchParams.append(key, String(value));
    }
  });

  return [...searchParams].length ? `?${searchParams.toString()}` : "";
}
